import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomizeProductAlV1Component } from './customize-product-al-v1/customize-product-al-v1.component';
import { QuantityStepperModule } from 'abs-ngx-library/src/lib/quantity-stepper';
import { CustomizeProductALV1Service } from './customize-product-al-v1/customize-product-al-v1.service';

@NgModule({
  declarations: [CustomizeProductAlV1Component],
  exports: [
    CustomizeProductAlV1Component,
  ],
    imports: [
        CommonModule,
        QuantityStepperModule
    ],
  providers: [
    CustomizeProductAlV1Component,
    CustomizeProductALV1Service
  ]
})
export class CustomizeProductModule { }
